<template>
  <Card :btnMsg="$t('star.btn_text')" @changeStep="changeStep" :embedded="embedded">
    <div class="card-star">
      <div class="card-content">
        <p class="card-title" v-html="$t('star.title')"></p>
        <div class="card-text" v-html="$t('star.text')"></div>
        <div class="star-box">
          <div class="star-item" v-for="item in form.questions" :key="item.question">
            <div class="star-q">{{ item.question }}</div>
            <a-rate class="star-a" :allowClear="false" v-model="item.star" :size="25" color="#FFD814" />
          </div>
        </div>
        <div class="written-box">
          <div class="card-text" v-html="$t('star.written')"></div>
          <a-textarea
            class="written-textarea"
            v-model="form.comment"
            :placeholder="$t('star.written_placeholder')"
            :auto-size="{ minRows: 4, maxRows: 8 }"
          />
        </div>
        <div class="good-bg">
          <img :src="goodBg" />
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/card.vue';
import { postSubmit } from '@/api/portal';

export default {
  components: {
    Card,
  },
  props: {
    embedded: { type: Boolean, default: false },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      giftCard: require('@/assets/gift-card.png'),
      goodBg: require('@/assets/good-bg.png'),
    };
  },
  mounted() {
    this.form = this.value;
  },
  methods: {
    changeStep() {
      if (this.form.questions.every(item => item.star)) {
        let len = this.form.questions.length;
        let starEnd = this.form.questions[len - 1];
        this.$emit('input', this.form);
        if (starEnd.star > 3) {
          // 好评
          if(this.form.default_channel_type===2){
            this.$parent.changeStep('defaultPaypalForm',this.form);
          }else{
            this.$parent.changeStep('channelSelect',this.form);
          }
        } else {
          // 差评
          if(this.form.default_channel_type===2){
            this.$parent.changeStep('defaultPaypalForm',this.form);
          }else{
          this.$parent.changeStep('ensureEmail',this.form);
          }
        }
      } else {
        this.$toast.fail(this.$t('star.star__placeholder'), this.lang);
      }
    },
  },
};
</script>

<style lang="scss">
.card-star {
  position: relative;
  width: 100%;
  .card-title {
    font-size: 23px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 10px;
  }
  .card-text {
    font-size: 19px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 16px;
  }
  .star-box {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: #f0f0f0;
    border-radius: 10px;
    margin-bottom: 16px;
    .star-item {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .star-q {
        width: fit-content;
      }
      .star-a {
        width: fit-content;
        flex: 1;
        display: flex;
        justify-content: end;
      }
      .ant-rate-star-full {
        .anticon {
          color: #ffd814;
        }
      }
      .ant-rate-star-zero {
        .anticon {
          color: #c0c0c0;
        }
      }
    }
  }
  .written-box {
    margin-bottom: 16px;
    .card-text {
      margin-bottom: 6px;
    }
    .written-textarea {
      background-color: #f0f0f0;
      border: 1px solid #f0f0f0;
      font-size: 16px;
      resize: none;
      color: #717070;
      &::placeholder {
        font-size: 16px;
        color: #717070;
      }
      &:focus {
        border: 1px solid #f0f0f0;
        box-shadow: none;
      }
    }
  }
  .good-bg {
    img {
      width: 100%;
    }
  }
  .van-swipe__indicator .van-swipe__indicator-item {
    background-color: #fff;
  }

  .van-swipe__indicator .van-swipe__indicator-item--active {
    background-color: #f4a300; /* 高亮颜色 */
  }
}
</style>
